import React, { useState } from 'react';
import { Flex, VStack, Image, Text } from '@chakra-ui/react';
import LoginContent from '../login/LoginContent';
import QuickRegisterContent from '../register/QuickRegisterContent';
import ForgotPassword from '../login/forgotPassword';
import SpotOnIcon from '../../media/images/SpotOnIcon.svg';

const SplashScreenContent = ({ contentProps }) => {
  const { currentView: initialView } = contentProps;
  const [currentView, setCurrentView] = useState(initialView ?? 'login');
  const projectName = 'Profit Assist';

  const renderContent = () => {
    switch (currentView) {
      case 'register':
        return <QuickRegisterContent onViewChange={setCurrentView} />;
      case 'forgotPassword':
        return <ForgotPassword onViewChange={setCurrentView} />;
      case 'login':
        return <LoginContent onViewChange={setCurrentView} />;
      default:
        return <LoginContent onViewChange={setCurrentView} />;
    }
  };

  return (
    <VStack
      h="100vh"
      w="100%"
      align="stretch"
      justify="flex-start"
      bg="gray.50"
      flexDirection="column"
      spacing="25%"
    >
      <Flex alignSelf="flex-start" ml={8} mt={8}>
        <Image src={SpotOnIcon} alt="SpotOn Logo" w="20px" mr={3} />
        <Text fontWeight={'600'} fontSize={'16px'}>
          {projectName}
        </Text>
      </Flex>

      <Flex justifyContent="center" alignItems="center" w="100%">
        {renderContent()}
      </Flex>
    </VStack>
  );
};

export default SplashScreenContent;
